import { render, staticRenderFns } from "./AttendanceDetail.vue?vue&type=template&id=c23d1de0"
import script from "../../services/attendance/attendance-detail.js?vue&type=script&lang=js&external"
export * from "../../services/attendance/attendance-detail.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/attendance/attendance-detail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports